import { CustomMessagesModel } from "../models/CustomMessages";
import { getBaseAPI } from "../environments/Environments";
import { reject } from "q";
import { mapSessionData, SessionModel } from "../models/Session";

export default class CustomMessagesService {
	static retrieveCustomMessages = (
		session: SessionModel
	): Promise<CustomMessagesModel> => {
		return new Promise(async (resolve) => {
			const url = await getBaseAPI() + "/api/v1/Patient/getCustomMessages";
			fetch(url, {
				method: "POST",
				body: JSON.stringify(mapSessionData(session)),
				headers: {
					"Content-Type": "application/json",
				},
			})
				.then((res) => res.json())
				.then((result) => Promise.resolve(result))
				.then((customMessagesResponse) => {
					resolve(customMessagesResponse);
				})
				.catch((e) => {
					console.log("request error", e);
					reject(e);
				});
		});
	};

	static retrieveEndingMessage = (
		session: SessionModel
	): Promise<CustomMessagesModel> => {
		return new Promise( async (resolve) => {
			const url = await getBaseAPI() + "/api/v1/Patient/getCustomMessages";
			fetch(url, {
				method: "POST",
				body: JSON.stringify(mapSessionData(session)),
				headers: {
					"Content-Type": "application/json",
				},
			})
				.then((res) => res.json())
				.then((result) => Promise.resolve(result))
				.then((customMessagesResponse) => {
					resolve(customMessagesResponse);
					console.log(customMessagesResponse)
				})
				.catch((e) => {
					console.log("request error", e);
					reject(e);
				});
		});
	};
}
